import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Video, Mic, Camera, GraduationCap, Target } from "lucide-react";

const services = [
  { id: "reels", name: "Reels", href: "/reels", icon: Video },
  { id: "podcasts", name: "Podcasts", href: "/podcasts", icon: Mic },
  { id: "evenements", name: "Événements", href: "/evenements", icon: Camera },
  { id: "formations", name: "Formations", href: "/formations", icon: GraduationCap },
  { id: "publicites", name: "Publicités", href: "/publicites", icon: Target },
];

const ServiceNavigation = () => {
  const location = useLocation();
  
  const getActiveService = () => {
    const path = location.pathname;
    const service = services.find(s => s.href === path);
    return service?.id || "reels";
  };

  const activeService = getActiveService();

  return (
    <div className="sticky top-20 z-40 py-4">
      <div className="container mx-auto px-6">
        <div className="flex justify-center">
          <div className="inline-flex items-center gap-1 p-1.5 rounded-full bg-card/80 backdrop-blur-sm border border-border/50">
            {services.map((service) => {
              const Icon = service.icon;
              const isActive = activeService === service.id;
              
              return (
                <Link
                  key={service.id}
                  to={service.href}
                  className="relative"
                >
                  <motion.div
                    className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors ${
                      isActive
                        ? "text-primary-foreground"
                        : "text-muted-foreground hover:text-foreground"
                    }`}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    {isActive && (
                      <motion.div
                        layoutId="serviceNavBubble"
                        className="absolute inset-0 bg-primary rounded-full"
                        transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                      />
                    )}
                    <Icon className="w-4 h-4 relative z-10" />
                    <span className="relative z-10 hidden sm:inline">{service.name}</span>
                  </motion.div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceNavigation;
